var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 8.00023V12.0002M11.9998 16.0002H12.0098M10.6151 2.89195L2.39019 17.0986C1.93398 17.8866 1.70588 18.2806 1.73959 18.6039C1.769 18.886 1.91677 19.1423 2.14613 19.309C2.40908 19.5002 2.86435 19.5002 3.77487 19.5002H20.2246C21.1352 19.5002 21.5904 19.5002 21.8534 19.309C22.0827 19.1423 22.2305 18.886 22.2599 18.6039C22.2936 18.2806 22.0655 17.8866 21.6093 17.0986L13.3844 2.89195C12.9299 2.10679 12.7026 1.71421 12.4061 1.58235C12.1474 1.46734 11.8521 1.46734 11.5935 1.58235C11.2969 1.71421 11.0696 2.10679 10.6151 2.89195Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.421c9277cbb3d8f11a6e5642d56c23ce.svg";
export { ForwardRef as ReactComponent };